import { MYSELF_CHANGED, } from 'actiontypes/myself';
import { parseChangeMessage } from './utils';
import { IQualityEffect } from 'types/qualities';
import { Dispatch } from 'redux';

export default function updateMyself(data: IQualityEffect[]) {
  const payload = data.map(parseChangeMessage);
  return (dispatch: Dispatch) => dispatch({
    payload,
    type: MYSELF_CHANGED,
  });
}
